import React from 'react';
import { FaqDef } from '../../types/Faq/faq.def';
import { Accordion } from '../../components/molecules/Accordion';
import showdown from 'showdown';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import emojis from 'theme/emoji';
import useStyle from './faq.style';

interface FaqViewProps {
  faqs: FaqDef[];
}

const FaqView = ({ faqs }: FaqViewProps) => {
  const converter = new showdown.Converter();
  const classes = useStyle();

  return (
    <ContainerFullWidth>
      <HeaderText text="Liste des questions" emoji={emojis['Books']} />
      <FeatureContainer padding="small">
        {faqs.map(faq => (
          <Accordion key={faq.id} title={faq.name}>
            <div
              className={classes.htmlText}
              dangerouslySetInnerHTML={{
                __html: converter.makeHtml(faq.desc)
              }}
            />
          </Accordion>
        ))}
      </FeatureContainer>
    </ContainerFullWidth>
  );
};
export default FaqView;
